import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// Element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 全局样式
import '@/assets/styles/global.scss';

// API
import api from '@/api';
import http from '@/api/http';

// 存储工具
import { cleanupInvalidStorage } from '@/utils/storage';

// 使用完整的Element UI配置
Vue.use(ElementUI, {
  size: 'small' // 设置组件默认尺寸
});

Vue.config.productionTip = false;

// 全局注册API
Vue.prototype.$api = api;
Vue.prototype.$http = http;

// 全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue全局错误:', err, info);
  
  // 检查是否是认证相关错误
  if (err.message && (
    err.message.includes('401') || 
    err.message.includes('未授权') || 
    err.message.includes('请先登录') ||
    err.message.includes('登录已过期')
  )) {
    // 清除用户数据并跳转到登录页
    store.dispatch('user/logout').then(() => {
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
    });
  }
};

// 全局未捕获的Promise错误处理
window.addEventListener('unhandledrejection', event => {
  console.error('未捕获的Promise错误:', event.reason);
  
  // 检查是否是认证相关错误
  if (event.reason && event.reason.message && (
    event.reason.message.includes('401') || 
    event.reason.message.includes('未授权') || 
    event.reason.message.includes('请先登录') ||
    event.reason.message.includes('登录已过期')
  )) {
    // 清除用户数据并跳转到登录页
    store.dispatch('user/logout').then(() => {
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
    });
  }
});

// 清理无效的localStorage数据
cleanupInvalidStorage();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
